'use strict';
var base = require('./base');
var common = require('brand_core/common');
var eGiftCard = require('brand_core/product/eGiftCard');
var breakpoints = require('brand_core/components/breakpoints');
const { debounce } = require('../utilities/utilities');
var customEmbroideryModal = require('./customEmbroideryModal');

/**
 * Prepares availability message to include 'Ships next business day' or not for embroidery & other products.
 * @param {Object} container - availability message container element
 * @param {Object} response - Product-Variation response object
 * @returns {Object} message - availabiliy message
 */
function prepareAvailabilityMessage(container, response) {
    var message = $.parseHTML(response.message);
    var embroidery = false;
    for (var i = 0; i < response.product.options.length; i++) {
        if (response.product.options[i].id === 'embroidery') {
            if (response.product.options[i].selectedValueId && response.product.options[i].selectedValueId === 'yes') {
                embroidery = true;
            } else {
                embroidery = false;
            }
        }
    }
    var availabilityMsg = $(container).data('availability-instock-msg');
    if (embroidery) {
        if (response.product.available) {
            $(message).find('p').html(availabilityMsg);
        }
    }
    return message && message !== '' ? message : '';
}

/**
 * update selected swatch element
 * @param {Object} element - selected element
 */
function updateSelectedSwatchValue(element) {
    const $selectedBtn = element;
    const selectedValue = $selectedBtn.find('.swatch-value').attr('data-attr-title');
    $selectedBtn.closest('.product-attribute').find('.selected-attr').text(selectedValue).removeClass('d-none');
    base.methods.toggleNewColorText($selectedBtn, $selectedBtn.closest('.product-attribute').find('.new-color-text'));
    base.methods.toggleFinalSaleText($selectedBtn, $selectedBtn.closest('.product-attribute').find('.final-sale-text'));
}

module.exports = {
    initResizeHandlers: base.initResizeHandlers,
    availability: base.availability,
    addToCart: base.addToCart,
    setColorAttribute: base.setColorAttribute,
    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.manufacturerSKU);
                response.container.find('.product-id').data('product-upc', response.data.product.id);
                response.container.find('.product-id').data('style-number', response.data.product.manufacturerSKU);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.manufacturerSKU);
                response.container.find('.product-id').data('product-upc', response.data.product.id);
                response.container.find('.product-id').data('style-number', response.data.product.manufacturerSKU);
            } else {
                $('.product-id').text(response.data.product.manufacturerSKU);
                $('.product-id').data('product-upc', response.data.product.id);
                $('.product-id').data('style-number', response.data.product.manufacturerSKU);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            var addToCart = $('button.add-to-cart', response.$productContainer);
            var bisnButton = $('button.bis-notify-me', response.$productContainer);
            var $bisContainer = $('.bisncontainer', response.$productContainer);
            var $bisnSubscriptionForm = $('.bisnSubscriptionForm');

            if (response.product.available) {
                addToCart.text(addToCart.data('available-msg'));
            } else {
                addToCart.text(addToCart.data('unavailable-msg'));
            }
            // Check if this is an eGift card product - if so, let eGiftCard.js handle it
            var isEGiftCard = response.product && response.product.isEGiftCard;
            if (isEGiftCard && response.product && response.product.available) {
                $('body').trigger('egiftcard:updateButton');
                return;
            }
            if (response.product.readyToOrder) {
                $('button.add-to-cart').closest('.cart-and-ipay').find('.invalidAttr').addClass('d-none');
                addToCart.removeClass('default-btn disabled');
            } else {
                addToCart.text(addToCart.data('selectsize-msg'));
                addToCart.addClass('default-btn');
            }

            if ($('.quick-modal.show').length > 0) {
                addToCart.attr('disabled', (!response.product.readyToOrder || !response.product.available));
            }

            if (response.product.isBIS && (!response.product.readyToOrder || !response.product.available)) {
                if (response.product.isBIS) {
                    $bisContainer.removeClass('d-none');
                    $bisnSubscriptionForm.removeClass('d-none');
                    addToCart.addClass('d-none');
                    bisnButton.text(bisnButton.data('bisnbutton-msg'));
                    bisnButton.attr('disabled', false);
                    base.methods.announceBisnMessages($bisnSubscriptionForm);
                } else {
                    $bisContainer.addClass('d-none');
                    $bisnSubscriptionForm.addClass('d-none');
                    addToCart.removeClass('d-none');
                }
            } else {
                $bisContainer.addClass('d-none');
                $bisnSubscriptionForm.addClass('d-none');
                addToCart.removeClass('d-none');
            }

            // Handle Custom Embroidery CTA visibility
            if (response.product && response.product.customEmbroidery) {
                var $embroideryCtaWrapper = $('.custom-embroidery-cta-wrapper', response.$productContainer);
                if (response.product.customEmbroidery.isCustomEmbroideredEligible && response.product.available) {
                    $embroideryCtaWrapper.removeClass('d-none');
                    // Update surcharge from site pref price
                    if (response.product.customEmbroidery.price) {
                        var priceFormatted = '+$' + Math.round(response.product.customEmbroidery.price) + ' PERSONALIZE IT';
                        $embroideryCtaWrapper.find('.custom-embroidery-cta-surcharge').text(priceFormatted);
                    }
                } else {
                    $embroideryCtaWrapper.addClass('d-none');
                }
            }

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);
            $('.availability-msg', response.$productContainer)
                .empty().html(function () {
                    return prepareAvailabilityMessage($(this), response);
                });
            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });
                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });
                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);
                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : '');
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a.size-chart-pdp__link, .size-chart button.size-chart-pdp__link').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty') || $prodSizeChart.text().trim() === '') {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });
        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    updateSwatchesSelectedValue: function () {
        $(document).on('click', '.swatch-attribute:not(.color-attribute)', function () {
            updateSelectedSwatchValue($(this));
        });
        var $allSelectedSwatches = $('.swatch-attribute.selected:not(.color-attribute)');
        $allSelectedSwatches.each(function (i, swatch) {
            updateSelectedSwatchValue($(swatch));
        });
    },
    stickyScrollAddToBagButton: function () {
        const $addToCartBtnParent = document.querySelector('.add-to-cart-main');
        const $html = document.querySelector('html');
        if (breakpoints.isMobileView()) {
            document.addEventListener('scroll', debounce(()=> {
                const initialCords = $addToCartBtnParent.getBoundingClientRect();
                if (initialCords.top < 0) {
                    $html.classList.add('pdp-sticky-btn');
                } else {
                    $html.classList.remove('pdp-sticky-btn');
                }
            }, 10));
        } else {
            $html.classList.remove('pdp-sticky-btn');
        }
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    initiateCarouselPDP: base.setSlickSlider,
    initiateZoom: base.loadZoom(),
    initiateLazyLoad: common.lazyLoad(),
    eGiftCard: eGiftCard.init
};

$(document).ready(function () {
    // Init Custom Embroidery Modal (PMG-2839)
    customEmbroideryModal.init();

    // Hide mobile zoom icon when video is active
    $('.pdp-main-carousel').on('afterChange', function () {
        if ($(this).find('.slick-list').find('.slick-active').find('.carousel-item')
            .hasClass('pdp-video')) {
            $('.js_mobile-zoom-icon').addClass('d-none');
        } else {
            $('.js_mobile-zoom-icon').removeClass('d-none');
        }
    });
});

// Appended logic for Shop The Look
$(document).ready(function () {
    var shopTheLook = require('brand_core/product/shopTheLook');
    shopTheLook.init();

    $('body').on('product:afterAttributeSelect', function (e, response) {
        var $wrapper = $('.shop-the-look-wrapper');
        if (!$wrapper.length) return;

        // 1. Do not update STL if the interaction happened inside a Quick Shop / modal
        if (response.container && (response.container.closest('.quick-view-dialog').length > 0 || response.container.closest('.modal').length > 0 || response.container.hasClass('product-quickview'))) {
            return;
        }

        var basePID = response.data.product.id;
        var color = null;
        if (response.data.product && response.data.product.variationAttributes && response.data.product.variationAttributes.length) {
            response.data.product.variationAttributes.forEach(function (attribute) {
                if (attribute.id === 'color' && attribute.values && attribute.values.length) {
                    attribute.values.forEach(function (attrVal) {
                        if (attrVal.selected) {
                            color = attrVal.id;
                        }
                    });
                }
            });
        }

        if (!color) return;

        // 2. Only update if the color actually changed
        var lastColor = $wrapper.attr('data-current-color');

        // If it's the exact same color, do nothing (e.g. user selected a size)
        if (lastColor === color) {
            return;
        }

        // Update the tracked color
        $wrapper.attr('data-current-color', color);

        var stlUrl = $wrapper.data('stl-url');
        if (stlUrl && basePID) {
            // Build clean URL with updated pid and colorCode
            var updateUrl = stlUrl.split('?')[0] + '?pid=' + basePID + '&colorCode=' + color;
            shopTheLook.update(updateUrl);
        }
    });

    // Initialize current color on page load
    $(document).ready(function () {
        var $wrapper = $('.shop-the-look-wrapper');
        if ($wrapper.length) {
            var initialColor = $('.product-detail[data-pid]').first().find('[data-attr="color"] .selected').data('attr-value')
                            || $('.product-detail[data-pid]').first().find('[data-attr="color"] option:selected').val();
            if (initialColor) {
                $wrapper.attr('data-current-color', initialColor);
            }
        }
    });
});
